import imgAboutMe from "../assets/img/me/mephoto.jpg"

export const ImgDataMe = [{
    id: 1,
    img: imgAboutMe
}]

